import React from "react";
import { motion } from "framer-motion";
function Achievements() {
    return (
        <div id="achievements" className="h-full !pt-12">
            <motion.div
                whileInView={{ y: [50, 0], opacity: [0, 1] }}
                transition={{ duration: 1, ease: "easeInOut" }}
                className="p-3 md:p-10 w-full text-center">
                <center>
                    <div className="w-fit font-mono font-extrabold text-transparent text-4xl md:text-5xl bg-clip-text bg-gradient-to-r from-[#15ff00] to-[#1cfffb]">
                        Achievements
                    </div>
                    <div className="font-mono mt-5">
                        I have participated in{" "}
                        <a
                            className="text-red-600 font-mono font-bold "
                            href="https://hacktoberfest.com/about/"
                            target="_blank"
                            rel="noopener noreferrer">
                            Hacktoberfest
                        </a>{" "}
                         and contributed to
                        open-source projects through it.
                    </div>
                    <br />
                    <div className="flex flex-wrap justify-center md:w-2/3">
                        <a
                            href="https://www.holopin.io/@shubhu_21#badges"
                            target="_blank"
                            rel="noopener noreferrer">
                            <img
                                className=""
                                src="https://holopin.me/@shubhu_21"
                                alt="Shubhankar's Holopin board"
                            />
                        </a>
                    </div>
                </center>
            </motion.div>
        </div>
    );
}

export default Achievements;
